import {flexRender} from "@tanstack/react-table";
import PropTypes from "prop-types";
import {ColumnFilter} from "./ColumnFilter.jsx";
import {ArrowsExpand, SortDown, SortUp} from "react-bootstrap-icons";

export const THead = ({tableInstance, addTh, hideSorting, sticky}) => {
    return (
        <thead className={sticky ? 'position-sticky top-0 bg-light z-1' : ''}>
        {tableInstance.getHeaderGroups()
            .map(headerGroup => (
                <tr key={headerGroup.id}>
                    {headerGroup?.headers.map(columnEl => (
                        <th key={columnEl.id}
                            colSpan={columnEl.colSpan}>
                            {
                                columnEl.isPlaceholder ? null : (
                                    <>
                                        <div onClick={columnEl.column.getToggleSortingHandler()}
                                             className={'d-flex flex-nowrap align-items-center gap-1'}>
                                            {!hideSorting && <div>
                                                {
                                                    {
                                                        asc: <SortUp color="#0d47a1"/>,
                                                        desc: <SortDown color="#0d47a1"/>,
                                                    }[columnEl.column.getIsSorted() ?? null] ||
                                                    <ArrowsExpand color="#999"/>
                                                }
                                            </div>}
                                            <div>
                                                {flexRender(
                                                    columnEl.column.columnDef.header,
                                                    columnEl.getContext())
                                                }
                                            </div>
                                        </div>
                                        {
                                            columnEl.column.getCanFilter() ?
                                                <ColumnFilter column={columnEl.column}
                                                              table={tableInstance}/>
                                                : null
                                        }
                                    </>
                                )
                            }
                        </th>

                    ))}
                    {addTh && addTh()}
                </tr>
            ))
        }
        </thead>
    )
}

THead.propTypes = {
    tableInstance: PropTypes.object.isRequired,
    addTh: PropTypes.func,
    hideSorting: PropTypes.func,
    sticky: PropTypes.bool,
}